module.exports = __webpack_public_path__ + "static/media/banner02.6a390190.jpg";